document.addEventListener("DOMContentLoaded", function () {
  const viewButtons = document.querySelectorAll(".view-details-button");

  viewButtons.forEach(button => {
    button.addEventListener("click", function () {
      const productHandle = this.dataset.productHandle;

      const popup = document.querySelector(`.product-detail-modal[data-product-handle="${productHandle}"]`);

      if (popup) {
        popup.classList.remove("hidden");
        document.body.classList.add("overflow-hidden");

        if (!popup.dataset.swiperInitialized) {
          initModalSwiper(popup);
          popup.dataset.swiperInitialized = "true";
        }
      }
    });
  });

  // Close popup on click or touch
  ["click", "touchend"].forEach(eventType => {
    document.addEventListener(eventType, function (e) {
      const closeBtn = e.target.closest(".close-popup");
      const overlay = e.target.closest(".modal-overlay");

      if (closeBtn || overlay) {
        e.stopPropagation();
        e.preventDefault();

        setTimeout(() => {
          const modal = e.target.closest(".product-detail-modal");
          if (modal) {
            modal.classList.add("hidden");
            document.body.classList.remove("overflow-hidden");
          }
        }, 50);
      }
    });
  });

  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".product-detail-modal").forEach(modal => modal.classList.add("hidden"));
      document.body.classList.remove("overflow-hidden");
    }
  });
});

  
  
  // PopUp Swiper
  function initModalSwiper(popup) {
    const thumbSwiper = new Swiper(popup.querySelector(".product-modal-thumb-swiper"), {
      spaceBetween: 16,
      slidesPerView: 5,
      watchSlidesProgress: true,
    });
  
    new Swiper(popup.querySelector(".product-modal-main-swiper"), {
      spaceBetween: 14,
      slidesPerGroup: 1,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSwiper,
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
        },
        768: {
          slidesPerView: 1,
        },
        992: {
          
        },
        1200: {
          
        },
        1440: {
          
        }
      }
    });
  }
  
  